export const SET_IS_PDP_RESP_PREVIEW_PAGE = 'SET_IS_PDP_RESP_PREVIEW_PAGE';

export function setIsPdpRespPreviewPage({ isPdpRespPreviewPage }) {
    return { type: SET_IS_PDP_RESP_PREVIEW_PAGE, isPdpRespPreviewPage };
}
